import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OfficeStatus } from '../../../../../../shared/office-status';
import { FruHttpService } from '../../../../../../services/fru-http.service';
import { AnalyticsService } from '../../../../../../services/analytics.service';
import { FastModeService } from '../../../../../../services/fast-mode.service';
import { query } from '@angular/animations';
@Component({
    selector: 'app-form-landing-body',
    templateUrl: './form-landing-body.component.html',
    styleUrls: ['./form-landing-body.component.scss'],
    standalone: false
})
export class FormLandingBodyComponent implements OnInit {
  @Input() state: string = '';
  public officeStatus: OfficeStatus;
  public headerText: string;

  redirectTries: number = 0;
  redirecting: boolean = false;
  showTop10: boolean = true;
  maxCashoutForm:string;
  // FRU calc-skin: landing renders as a home-equity calculator (ad traffic ?calc=homeequity). Loan type pre-set to home equity.
  calcSkin: boolean = false;

  constructor(
    private router: Router,
    private fruHttp: FruHttpService,
    private analyticsService: AnalyticsService,
    public fastMode: FastModeService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    if (document.location.search.indexOf('best=best') > -1) {
      this.showTop10 = false;
    }
    const qp = this.route.snapshot.queryParams;
    this.calcSkin = qp['calc'] === 'homeequity' || qp['calcSkin'] === '1';
    if (this.calcSkin) { this.showTop10 = false; }
  }

  /** FRU calc-skin: home-equity calculator CTA -> home-equity flow, carrying the calc skin into the form. */
  calcContinue() {
    this.redirectForm('refinance', 'heloc', 'homeequity');
  }

  /** ⚡ FAST toggle on the landing. Flips the FAST mode service on/off. */
  toggleFast() {
    if (this.fastMode.enabled) {
      this.fastMode.disable();
    } else {
      this.fastMode.enable();
      window['_paq'].push(['trackGoal', 138]);
    }
  }

  redirectForm(type: string, formType?: string, maxCash?: string) {

    this.maxCashoutForm = maxCash;

    if (this.redirecting) {
      return;
    }

    this.redirecting = true;
    this.analyticsService.trackQuestionAnswered();
    this.navigateForm(type, formType);
  }

  navigateForm(type: string, formType: string) {
    this.redirecting = false;

    let qp = {};
    qp['LoanPurpose'] = type;

    if (formType) {
      qp['FormType'] = formType;
    }

    if (this.maxCashoutForm) {
      qp['maxCashoutForm'] = this.maxCashoutForm;
    }

    // FRU calc-skin: carry the calculator skin into the rates-form so it's one continuous calculator experience.
    if (this.calcSkin) { qp['calc'] = 'homeequity'; }

    // Carry the FAST opt-in into the form as a routing/tracking signal.
    if (this.fastMode.enabled) {
      qp['auto_mode'] = 'yes';
      qp['fast_mode_enabled_step'] = 'landing';
    }

    this.router.navigate(['/rates-form'], { queryParams: qp, queryParamsHandling: 'merge' });
  }

  adDisclosurePopup() {
    this.fruHttp.adDisclosurePopup();
  }
}
